module.exports = __webpack_public_path__ + "img/banner.7113ada0.png";